export default "__VITE_ASSET__82bb4ae6__"